module.exports = __webpack_public_path__ + "media/images/lb/778-8fdc59134d0cba1ea0f8dbeceba12f2c.svg";